import React from "react";
import "../css/privacy.scss";

function CookiePolicy() {
  return <main className="privacy-page"><div className="content-container">
    <h1 className="page-title">cookie policy</h1>
    <p>Last updated: 8 October 2026</p>
    <h2 className="section-main-heading">HOW WE USE COOKIES</h2><p>pmistpearl uses essential browser storage and cookies to keep the cart, checkout and security features working. These are necessary to provide the service you request.</p>
    <h3 className="section-sub-heading">ESSENTIAL COOKIES</h3><p>These remember cart contents, checkout state and basic preferences. Blocking them may prevent shopping functions from working correctly.</p>
    <h3 className="section-sub-heading">ANALYTICS</h3><p>If analytics are enabled, aggregated usage information helps us understand page performance. We do not use analytics cookies for unrelated advertising.</p>
    <h3 className="section-sub-heading">YOUR CHOICES</h3><p>You may clear or block cookies in your browser settings. Essential functions may be unavailable afterwards. Questions can be sent to service@pmistpearl.work.</p>
  </div></main>;
}
export default CookiePolicy;
